"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Context = _interopRequireDefault(require("./Context"));

var _material = require("@mui/material");

var _actions = require("./store/actions");

var _reducer = _interopRequireDefault(require("./store/reducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Provider = function Provider(_ref) {
  var appConfig = _ref.appConfig,
      children = _ref.children,
      _ref$persistKey = _ref.persistKey,
      persistKey = _ref$persistKey === void 0 ? 'menu' : _ref$persistKey;

  var _ref2 = appConfig || {},
      menu = _ref2.menu;

  var initialAuthMenuOpen = menu.initialAuthMenuOpen,
      initialMiniMode = menu.initialMiniMode,
      initialMenuOpen = menu.initialMenuOpen,
      initialMobileMenuOpen = menu.initialMobileMenuOpen,
      initialMiniSwitchVisibility = menu.initialMiniSwitchVisibility,
      useWindowWatcher = menu.useWindowWatcher;
  var savedState = JSON.parse(localStorage.getItem(persistKey));

  var _useReducer = (0, _react.useReducer)(_reducer.default, _extends({
    isAuthMenuOpen: initialAuthMenuOpen,
    isMiniMode: initialMiniMode,
    isMenuOpen: initialMenuOpen,
    isMobileMenuOpen: initialMobileMenuOpen,
    isMiniSwitchVisibility: initialMiniSwitchVisibility
  }, savedState)),
      menuStore = _useReducer[0],
      dispatch = _useReducer[1];

  var props = {
    //setter
    toggleThis: function toggleThis(value, newValue) {
      if (newValue === void 0) {
        newValue = null;
      }

      if (value === 'isAuthMenuOpen') {
        dispatch((0, _actions.setIsAuthMenuOpen)(newValue !== null ? newValue : !menuStore.isAuthMenuOpen));
      } else if (value === 'isMiniMode') {
        dispatch((0, _actions.setIsMiniMode)(newValue !== null ? newValue : !menuStore.isMiniMode));
      } else if (value === 'isMenuOpen') {
        dispatch((0, _actions.setIsMenuOpen)(newValue !== null ? newValue : !menuStore.isMenuOpen));
      } else if (value === 'isMobileMenuOpen') {
        dispatch((0, _actions.setIsMobileMenuOpen)(newValue !== null ? newValue : !menuStore.isMobileMenuOpen));
      } else if (value === 'isMiniSwitchVisibility') {
        dispatch((0, _actions.setIsMiniSwitchVisibility)(newValue !== null ? newValue : !menuStore.isMiniSwitchVisibility));
      }
    },
    //getters
    isAuthMenuOpen: menuStore.isAuthMenuOpen,
    isMiniMode: menuStore.isMiniMode,
    isMenuOpen: menuStore.isMenuOpen,
    isMobileMenuOpen: menuStore.isMobileMenuOpen,
    isMiniSwitchVisibility: menuStore.isMiniSwitchVisibility
  };
  var isDesktop = (0, _material.useMediaQuery)('(min-width:600px)');
  (0, _react.useEffect)(function () {
    try {
      localStorage.setItem(persistKey, JSON.stringify(menuStore));
    } catch (error) {
      console.warn(error);
    }
  }, [menuStore, persistKey]);
  (0, _react.useEffect)(function () {
    if (useWindowWatcher) {
      if (!isDesktop) {
        props.setMenuOpen(false);
        props.setMiniMode(false);
      }
    }
  }, [isDesktop, props, useWindowWatcher]);
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: _extends({
      isDesktop: isDesktop
    }, props)
  }, children);
};

Provider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any
} : {};
var _default = Provider;
exports.default = _default;
module.exports = exports.default;